module.exports = __webpack_public_path__ + "assets/img/6459e386227920bd30f195cc008462bd.png";